module.exports = __webpack_public_path__ + "img/BRCA2_pDC.99691f28.png";